// @format

import "jquery";
import { Turbo, cable } from "@hotwired/turbo-rails";
import Chartkick from "chartkick";
import RailsUJS from "@rails/ujs";
import "chartkick/chart.js"
import "bootstrap";

// Initialize Stimulus
import "../js/controllers";

RailsUJS.start();
Turbo.start();

window["Chartkick"] = Chartkick;
window["Turbo"] = Turbo;

// Expose functions for AJAX callbacks
import { initCustomerTableSort } from "../js/customer_success/table_sort";
import { initCustomersTable, applyCustomerTableMaxHeight } from "../js/cs_dashboard";
import { initViewToggle } from "../js/view_toggle";
import { initCandidateSearchAsYouType } from "../js/candidate_search";
import { initCandidateNotesLog } from "../js/candidate_notes_log";
import { initHistoryPopover } from "../js/history_popover";
import { initSetupGuide } from "../js/setup_guide";
import { initAdminPanel } from "../js/admin_panel";
import { initCandidatesFilters } from "../js/candidates_filters";
import { initSearchPreviewsFilter } from "../js/search_previews_filter";
import { initCandidatesAdvancedFilter } from "../js/candidates_advanced_filter";
import { initEmailComposerListeners } from "../js/utils/bots_prospects/init_email_composer_button_listeners";
import { initLinkedinComposerListeners } from "../js/utils/bots_prospects/init_linkedin_composer_button_listeners";
import { initProfileCardPhoneRefetch } from "../js/utils/bots_prospects/init_profile_card_phone_refetch";
import { initCandidatesFollowup } from "../js/utils/bots_prospects/init_candidates_followup";
import { mountLogos } from "../js/utils/bots_prospects/mount_logo";
window["initCustomerTableSort"] = initCustomerTableSort;
window["initCustomersTable"] = initCustomersTable;
window["applyCustomerTableMaxHeight"] = applyCustomerTableMaxHeight;
window["initToolTableInteractions"] = initToolTableInteractions;
window["initCustomerSuccessDropdown"] = initCustomerSuccessDropdown;
window["initFullScreenToggle"] = initFullScreenToggle;
window["initDrawer"] = initDrawer;
window["initSummernote"] = initSummernote;
window["mountLogos"] = mountLogos;

import { initBotsProspectsGrid } from "../js/grid";
import { initCandidateBulk } from "../js/candidate_bulk";
import { initCandidateColumnOrder } from "../js/candidate_column_order";
import { initCandidateColumnResize } from "../js/candidate_column_resize";
import { initExpandableCells } from "../js/expandable_cells";
import { initHideColumnsMenu } from "../js/phone_dashboard/hide_columns_menu";
import { initCandidateClassify } from "../js/candidate_classify";
import { initCandidatePersonalize } from "../js/candidate_personalize";
import { initAllCandidatesBulkPhone } from "../js/all_candidates_bulk_phone";
import { initCandidateDrawer } from "../js/candidate_drawer";
import { initCompanyNameEditor } from "../js/company_name_editor";
import {
  initBotsProspectReplyModal,
  initPaginationLimitButtons,
  initBotsProspectProfileModal,
  initRenderGroupedCandidatesByCompany,
  initCandidatesDataProcessingStatusCheck,
  initAIReviewStatusCheck,
  initExportCandidatesCsv
} from "../js/bots_prospect";
import { initHeader } from "../js/header";
import { initSubmitOnChange } from "../js/submit_on_change";
import { initChoices } from "../js/choices";
import {
	initEmailResponses,
	initEmailResponsesFilters,
	initFullThreadEmailResponses,
} from "../js/email_responses";
window["initEmailResponsesFilters"] = initEmailResponsesFilters;
import { initTodo } from "../js/todo";
import { initCRMHiddenListener } from "../js/crm";
import { initContacted, initContactedReply } from "../js/contacted";
import { initLoginForm } from "../js/log_in";
import { initNotes } from "../js/notes";
import { initLitepicker, destroyLitepicker } from "../js/litepicker";
import { initInterestedExport } from "../js/interested_export";
import { initCampaignOverview } from "../js/campaign_overview";
import {
	initProspectToggle,
	initEditProspectListener,
	initPhoneCompletedListener,
	initEmailsReceived,
	initRejectReasonListener,
	initReApproachedBtn,
	initCheckedBotsProspect,
	initBotProspectHistory,
	initPersonalizedMessage,
	initFetchPhoneButton,
	initSendConnectionRequestLinkedInModal,
	initWriteWithAIButton,
	initStatusCallingDropdown,
  initContactCandidateButton,
  initRejectAllCandidatesButton,
  initCallButton,
  initShowAllSkillsButton,
  initShowProspectDetailBtn,
  initShowProspectAiReviewBtn,
  initMarkAsPassedBtn,
  initRequestAdditionalProspectsButton
} from "../js/prospect";
import { initFetchEmailButton, initEmailModalButton } from "../js/contacts/email_address";
import { initTooltips } from "../js/tooltip";
import { initToggle } from "../js/toggle";
import { initTeamtailor } from "../js/teamtailor";
import { initAirtable } from "../js/airtable";
import { initDatePicker } from "../js/date_picker";
import { initScheduleDate } from "../js/schedule_date";
import { initQlfrModal, initAiSequenceModal } from "../js/qlfr_modal";
import { initSearchPreviews } from "../js/search_previews";
import { initAdsPoolSearch } from "../js/ads_pool_search";
import { initLanguagePicker } from "../js/language_picker";
import { initFront } from "../js/front";
import { initSelectpicker, destroySelectpicker } from "../js/selectpicker";
import { initInboxManagement } from "../js/inbox_management";
import { initCustomSelect } from "../js/custom_select";
import { initDestroySequenceListener, initSequence } from "../js/sequences";
import { initDestroyBotListener, initShowSequences } from "../js/bots";
import { initDisconnectMailListener } from "../js/users";
import {
	initSummernote,
	destroySummernote,
	initOptOutSetter,
	checkOptOutPresence,
} from "../js/summernote";
import { initCommentSidebar } from "../js/comment_sidebar";
import { initHomeBanner } from "../js/home_banner";
import { initAutosize } from "../js/textarea";
import { initTimeZone } from "../js/time_zone";
import { initOverview } from "../js/overview";
import { initUserCompanies } from "../js/user_companies";
import { initCsvSelectsListener } from "../js/csv_data_import";
import { initCreditBatches } from "../js/credit_batches";
import { initClipCopy } from "../js/clip_copy";
import { initNotifier } from "../js/notifier";
import { initFileUpload } from "../js/file_upload";
import { initHubspot } from "../js/hubspot";
import { initMetaAdSearch, initCreativeTypeSelect } from "../js/meta_api"
import { initMediaPreview } from "../js/media_preview"
import { initAdsetDisclosure } from "../js/adset_disclosure"
import { initStickyMetrics } from "../js/sticky_metrics"
import { initAdCampaignTotalCount, initAdsTabCounts, applyActiveFilteredCount, loadAdsTabStats } from "../js/ad_campaign_total_count"
import { initAdCampaignSelection } from "../js/ad_campaign_selection"
import { initAdSetSelection } from "../js/ad_set_selection"
import { initDrawer } from "../js/drawer";
import { initNoteDrawer } from "../js/note_drawer";
import { initToggleStatusHubspot } from "../js/toggle_status_hubspot";
import { initHubspotCompanySelect, initApiLogoSelect, initAdminUsersCompanySelect } from "../js/cs_dashboard";
import { toggleMobileSidebar, initNavDropdowns, initSidebarToggle } from "../js/sidebar";
import { initCsList } from "../js/customer_success/list";
import { initBotGoal } from "../js/bot_goal";
import { initCustomerSuccessDropdown } from "../js/customer_success/dropdown_navigation";
import { initFullScreenToggle } from "../js/customer_success/full_screen_toggle";
import { initCustomerSuccessTagsSelect } from "../js/customer_success/tags_select";
import { initAddMaterial, initMaterialSearch, initViewMaterial } from "../js/meta_ads_material"
import { initAsyncLoader } from "../js/async_loader";
import { initPhoneVerification } from "../js/phone_verification";
import {
	initAdCampaign,
	destroyAssignmentDropdowns
} from "../js/ad_campaign/index";
import "../js/user_company_show";
import { initDropdowns } from "../js/utils/bots_prospects/custom_select_dropdown";
import "../js/user_company_show";
import { initAdSet } from "../js/ad_set";
import { initTextByteTruncation } from '../js/ad_campaign/dom-helpers'

// css
import "choices.js/assets/styles/css/choices.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "summernote/dist/summernote-bs4.css";
import "../application.scss";
import { initToolTableInteractions } from "../js/cs_edit";
import "../js/controllers";

$(document).on("turbo:load", function (event) {
	initSearchPreviews();
	initSearchPreviewsFilter();
	initAdsPoolSearch();
	initSelectpicker();
	initCandidateSearchAsYouType();
});

$(document).on("turbo:load turbo:render", function (event) {
	window.scrollTo(0, 0); // force scroll to top at all times
	initLitepicker();
	initCampaignOverview();
	initToggle();
	initAutosize();
	initHeader();
	initChoices();
	initTooltips();
	initHubspot();
	initCommentSidebar();
	initCRMHiddenListener();
	initLoginForm();
	initEmailResponses();
	initTodo();
	initCheckedBotsProspect();
	initCandidateBulk();
	initCandidateClassify();
	initCandidatePersonalize();
	initCandidateDrawer();
	initProfileCardPhoneRefetch();
	initCandidatesFollowup();
	initCandidateNotesLog();
	initHistoryPopover();
	initSetupGuide();
	initAdminPanel();
	initCandidatesFilters();
	initCandidatesAdvancedFilter();
	initOverview();
	initTimeZone();
	initNotes();
	initContacted();
	initContactedReply();
	initTeamtailor();
	initAirtable();
	initSelectpicker();
	initInboxManagement();
	initCustomSelect();
	initSequence();
	initSummernote();
	initClipCopy();
	initUserCompanies();
	initCsvSelectsListener();
	initCreditBatches();
	initNotifier();
	initFileUpload();
	initDatePicker();
	initScheduleDate();
	initQlfrModal();
	initAiSequenceModal();
	//initOptOutSetter();
	checkOptOutPresence();
	initFront();
	initFullThreadEmailResponses();
	setBudgetFieldsVisibility();
	initMetaAdSearch();
	initAdCampaignSelection();
	initAdSetSelection();
	loadAdsTabStats();
	initCreativeTypeSelect();
	initMediaPreview();
	initAdsetDisclosure();
	initStickyMetrics();
	initRenderCsStats();
	initHubspotCompanySelect();
	initApiLogoSelect();
	initAdminUsersCompanySelect();
	initDrawer();
	initNoteDrawer();
	initFetchPhoneButton();
	initCallButton();
	initToggleStatusHubspot();
	initConfirmationPopup();
	initAdsPoolConfirmationPopup();
	initRenderGroupedCandidatesByCompany();
	toggleMobileSidebar();
	initCandidatesDataProcessingStatusCheck();
	initAIReviewStatusCheck();
	initExportCandidatesCsv();
	initInterestedExport();
	initCustomerSuccessDropdown();
	initFullScreenToggle();
	initCustomerSuccessTagsSelect();
	initCustomerTableSort();
	initAsyncLoader();
	initPhoneVerification();
	toggleMobileSidebar();
	initCustomerSuccessDropdown();
	initFullScreenToggle();
	initCustomerSuccessTagsSelect();
	initCustomerTableSort();
	initAddMaterial();
	initMaterialSearch();
	initViewMaterial();
	initToolTableInteractions();
	initCustomersTable();
  	initAdCampaign();
	initDropdowns();
	initAdSet();
	initTextByteTruncation();
	initFetchEmailButton();
	initEmailModalButton();
	mountLogos();
});

initNavDropdowns();
initSidebarToggle();
initCsList();
initBotGoal();
initHomeBanner();
initProspectToggle();
initContactCandidateButton();
initRejectAllCandidatesButton();
initRequestAdditionalProspectsButton();
initLanguagePicker();
initEditProspectListener();
initCompanyNameEditor();
initPhoneCompletedListener();
initDestroyBotListener();
initDisconnectMailListener();
initShowSequences();
initDestroySequenceListener();
initEmailsReceived();
initReApproachedBtn();
initRejectReasonListener();
initFullThreadEmailResponses();
initSubmitOnChange();
initBotProspectHistory();
initPersonalizedMessage();
initSummernote();
initDrawer();
initNoteDrawer();
initSendConnectionRequestLinkedInModal();
initWriteWithAIButton();
initToggleStatusHubspot();
initCustomersTable();
initShowAllSkillsButton();
initShowProspectDetailBtn();
initShowProspectAiReviewBtn();
initMarkAsPassedBtn();
initAddMaterial();
initMaterialSearch();
initViewMaterial();
initAdCampaign();
initContacted();
initDropdowns();
initTextByteTruncation();
initFetchEmailButton();
initEmailModalButton();
mountLogos();

$(document).on("render_async_load", () => {
	initMediaPreview();
	initAdsetDisclosure();
	initAdCampaignTotalCount();
	initAdsTabCounts();
	applyActiveFilteredCount();
	initAdCampaignSelection();
	initAdSetSelection();
	initBotsProspectsGrid();
	initCandidateColumnOrder();
	initCandidateColumnResize();
	initExpandableCells();
	initHideColumnsMenu();
	initAllCandidatesBulkPhone();
	initViewToggle();
	initCandidatesAdvancedFilter();
	initBotsProspectReplyModal();
	initBotsProspectProfileModal();
	initPaginationLimitButtons();
	initSelectpicker();
	initClipCopy();
	initFullThreadEmailResponses();
	initPersonalizedMessage();
	initDrawer();
	initSummernote();
	initNoteDrawer();
	// idempotent — covers the case where the drawer markup arrives with the async payload
	initCandidateDrawer();
	initFetchPhoneButton();
	initStatusCallingDropdown();
	initCallButton();
	initEmailModalButton();
	initEmailComposerListeners();
	initLinkedinComposerListeners();
	initProfileCardPhoneRefetch();
	initSendConnectionRequestLinkedInModal();
	// Bootstrap popovers are opt-in (no data-API auto-init) and the phone buttons
	// arrive with the async-loaded table, after the turbo:load popover init has
	// already run — so (re)initialise them here. This drives the "fetch phone
	// number" popover on candidates with no number on file.
	$('[data-toggle="popover"]').popover({ html: true, sanitize: false, trigger: 'click' });
	initCandidateSearchAsYouType();
	initToggleStatusHubspot();
  initShowProspectDetailBtn();
  initShowProspectAiReviewBtn();
  initMarkAsPassedBtn();
	initCandidatesDataProcessingStatusCheck();
	initAIReviewStatusCheck();
	initAdSet();
	mountLogos();
	initCampaignOverview();

	const async_charts = $("#async-chart, #async-chart-2, #async-chart-3");

	async_charts.each((_, chart) => {
		const $chart = $(chart);

		const id = $chart.attr("id");
		const data = $chart.data("chart-data");
		const options = $chart.data("chart-options");
		const chartType = $chart.data("chart-type") || "ColumnChart";

		new Chartkick[chartType](id, data, options);

		initLitepicker();
	});
	// initSelectpicker();
	initClipCopy();
	//initFullThreadEmailResponses();
	initSubmitOnChange();
	addClickToAdCampaignTabs();
	initAddMaterial();
	initMaterialSearch();
	initViewMaterial();
});

$(document).on("turbo:before-cache", () => {
	destroySummernote();
	destroySelectpicker();
	destroyAssignmentDropdowns();
	destroyLitepicker();

	$("script[nonce]").each(function (index, element) {
		$(element).attr("nonce", element.nonce);
	});
});

function addClickToAdCampaignTabs() {
	$('.ad-campaign-tabs .tab').off('click').on('click', function () {
		const $container = $(".performance-metrics #render-async-stats")
		const url = $(this).data('url')
		const start_date = $('#litepicker').data('start-date')
		const end_date = $('#litepicker').data('end-date')

		$(this).addClass('active');
		$('.ad-campaign-tabs .tab').not(this).removeClass('active');
		$container.html("<div class='spinner-border text-primary'></div>")
		$container.attr('data-url', url)

		$.get(url, { start_date: start_date, end_date: end_date }, function (data) {
			$container.html(data)
		})
	});
}

function setBudgetFieldsVisibility() {
	$('#adset-campaign-id-dropdown').on('change', function () {
		const selectedOption = $(this).find('option:selected');
		const isCampaignBudget = selectedOption.data('campaign-budget');

		if (isCampaignBudget) {
			$('#adset-budget-fields').hide();
			$('#campaign-budget-set-msg').show();
		} else {
			$('#adset-budget-fields').show();
			$('#campaign-budget-set-msg').hide();
		}
	});
}

function initRenderCsStats() {
	$(".toggle-button").off("click").on("click", function () {
		if ($(this).find(".toggle").hasClass("collapsed")) {
			const $ele = $(this).parent().next().find('.render-cs-stats')
			$.get($ele.data("url"), function (data) {
				$ele.html(data)
			})
		}
	});
}

function initEnqueueCandidatesPopup(buttonId: string, confirmModalId: string): void {
	const $submitBtn = $(buttonId);
	if (!$submitBtn.length) return;

	const $confirm = $(confirmModalId);
	const $loading = $("#enqueue-loading-popup");

	function settle(): void {
		$loading.removeClass("active");
		$submitBtn.prop("disabled", false).removeClass("is-loading").removeAttr("aria-busy");
	}

	$submitBtn.off("click").on("click", function (e) {
		e.preventDefault();

		// leave the label and its icon alone — the loading card carries the wait
		$submitBtn.prop("disabled", true).addClass("is-loading").attr("aria-busy", "true");
		$confirm.removeClass("active");
		$loading.addClass("active");

		$.ajax({
			url: $(this).closest("form.button_to").attr("action"),
			type: "POST",
			success: function (response) {
				settle();

				if (response.success) {
					$("#success-popup").addClass("active");
					$("#success-popup .hint-text").text(response.message);
					return;
				}

				$("#fail-popup").addClass("active");
				$("#fail-popup .hint-text").html(response.message);
				// credits are the one failure the user can act on from here
				$("#enqueue-batch-btns").toggleClass("hidden", response.reason === "no_permission");
			},
			// without this the loading card sits there forever on a dropped request
			error: function () {
				settle();
				$("#fail-popup").addClass("active");
				$("#fail-popup .hint-text").text(
					"Something went wrong while enqueueing. Please try again — if it keeps failing, contact support."
				);
				$("#enqueue-batch-btns").addClass("hidden");
			},
		});
	});
}

function initConfirmationPopup() {
	initEnqueueCandidatesPopup("#submit-enqueue-candidates-btn", "#confirmation-popup");
}

function initAdsPoolConfirmationPopup() {
	initEnqueueCandidatesPopup("#submit-ads-pool-btn", "#ads-pool-confirmation-popup");
}
